import { createContext } from 'react';

// Context object lives in its own non-component module so its identity
// survives React Fast Refresh — a module mixing createContext() with
// components/hooks gets fully re-executed on hot reload, which would create
// a new context instance the already-mounted provider doesn't know about.

export const KeepAliveContext = createContext<null>(null);
